export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const SET_SESSION_TYPE = 'SET_SESSION_TYPE';
export const CLEAR_SESSION_DATA = 'CLEAR_SESSION_DATA';
export const SET_SESSION_STATUS = 'SET_SESSION_STATUS';
export const SET_SESSION_VIDEO_STATUS = 'SET_SESSION_VIDEO_STATUS';
export const SET_LESSON_SETTINGS = 'SET_LESSON_SETTINGS';
export const SET_LESSON_DELIVERY_ID = 'SET_LESSON_DELIVERY_ID';
export const SET_LESSON_JOIN_CODE = 'SET_LESSON_JOIN_CODE';

export const SESSION_STATUS_INACTIVE = 'inactive';
export const SESSION_STATUS_ACTIVE = 'active';
export const SESSION_STATUS_REJOINED = 'rejoined';

export function setSessionType(sessionType) {
    return { type: SET_SESSION_TYPE, sessionType };
}

export function setSessionData(sessionId, sessionType) {
    return { type: SET_SESSION_DATA, sessionId, sessionType };
}

export function clearSessionData() {
    return { type: CLEAR_SESSION_DATA };
}

export function setSessionStatus(sessionStatus) {
    // Used to keep track of when the user:
    // (1) Has been disconnected from the server session (inactive)
    // (2) Is connected to the server and has session data (active)
    // (3) Has been rejoined to the server session after a disconnect (rejoined)
    return { type: SET_SESSION_STATUS, sessionStatus };
}

export function setLessonSettings(settings) {
    return { type: SET_LESSON_SETTINGS, settings };
}

export function setSessionVideoStatus(videoStatus) {
    return { type: SET_SESSION_VIDEO_STATUS, videoStatus };
}

export function setLessonDeliveryId(lessonDeliveryId) {
    return { type: SET_LESSON_DELIVERY_ID, lessonDeliveryId };
}

export function setLessonJoinCode(lessonJoinCode) {
    return { type: SET_LESSON_JOIN_CODE, lessonJoinCode };
}
